var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailRead({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mail-read-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svg mail-read",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mail-read") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.07,10.33c-.31-.31-7-5.44-8.55-6.52C21.28,2.72,18.8.39,16.16.39,13.36.39,11,2.72,9.63,3.81,8.08,5.05,1.4,10.17,1.09,10.33a6.41,6.41,0,0,0-.78,1.09A3,3,0,0,0,0,12.66v16a3.06,3.06,0,0,0,3,2.95h26.1A2.85,2.85,0,0,0,32,28.66v-16a3.71,3.71,0,0,0-.31-1.24A1.57,1.57,0,0,0,31.07,10.33ZM29.2,28.19c0,.16,0,.16-.15.31a.56.56,0,0,1-.31.16H3.42c-.16,0-.16,0-.31-.16A.52.52,0,0,1,3,28.19V12.82c0-.16,0-.16.16-.32,1.08-.77,7-5.28,8.39-6.52,1.08-.93,3.1-2.8,4.66-2.8S19.73,5.05,20.82,6c1.55,1.09,7.3,5.75,8.23,6.52a.15.15,0,0,1,.15.16V28.19Zm-2-11.34c.32.32.16.78-.15,1.09-1.86,1.4-3.73,2.95-4.51,3.42-1.39,1.09-3.72,3.42-6.52,3.42s-5.13-2.33-6.52-3.42c-.78-.62-2.65-2-4.51-3.42a1,1,0,0,1-.15-1.09l.93-1.08a1,1,0,0,1,1.08-.16c2,1.4,3.89,2.8,4.67,3.42,1.08.78,3.1,2.8,4.66,2.8S19.57,20,20.82,19c.77-.62,2.64-2,4.35-3.42.31-.31.77-.15,1.08.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailRead);
export default __webpack_public_path__ + "static/media/mail-read.978a7a54874cfbce9d736a029f23ea9a.svg";
export { ForwardRef as ReactComponent };